exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.transition{z-index:-1;opacity:.5;transition:opacity .5s ease-out;width:auto}.sticky,.sticky-bottom{opacity:1}.sticky{position:fixed;top:0;width:inherit}.sticky-bottom{position:absolute;bottom:0;width:100%}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/fixed-summary-container/fixed-summary-container.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/fixed-summary-container/fixed-summary-container.component.scss
// module chunks = 0